import axios from "axios";
import { Fragment, useState } from "react";
import React, { CSSProperties } from "react";
import { Dialog, Menu, Transition, Disclosure } from "@headlessui/react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  MenuAlt2Icon,
  ShoppingBagIcon,
  UsersIcon,
  XIcon,
  ExclamationIcon,
  DocumentIcon,
  ArchiveIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  TemplateIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ArrowSmDownIcon,
  ArrowSmUpIcon,
  ScaleIcon,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import {ToastContainer, toast } from 'react-toastify';


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}


class Preferences extends React.Component {
  constructor(props) {
    super(props);
    this.state = {     
      showmsg: false,
      cryptKey: "",
      showSucessmsg: "Successfully Saved",
      overLay: "fixed inset-0 bg-black/50 ",
      setting_preference:[],
    };
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };

  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };

  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };

  open = async (e) => {
    this.setState({ sidebarOpen: true });
  };

  delete = async (e) => {
    this.setState({ deletealartmsg: true });
    this.setState({ cryptKey: e });
  };

  componentDidMount() {
     // const customId = "custom-id-yes";
    //toast("Lorem ipsum dolor",{toastId: customId});
    const token = localStorage.getItem("token");

    const res = axios
    .get("public/api/setting/preferences", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
    .then((res) => {
      this.setState({setting_preference:res.data.setting_preferences});
        //console.log(this.state.setting_preferences);
    });
  }

  
  
  handleChangeCheckboxdiscountpreference=(index)=>(e)=>{
    
    let value=this.state.setting_preference[index].setting_preference_status==0?(1):(0);
    this.state.setting_preference[index].setting_preference_status=value;

    this.setState({setting_preference:this.state.setting_preference});
    
  }


  addcustomer = (e) => {
    this.setState({ redirect: true });
  };
  

  saveCustomer=async (e)=>{

    e.preventDefault();
    console.log(this.state.setting_preferences);
    
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post("public/api/setting/preference/update", this.state, {
      headers,
    });

    if (res.data.success) {
          this.setState({showmsg:true});

          
    }

  }

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };





  render() {
    let token = localStorage.getItem("token");

    if (this.state.deleteRedirect) {
     // window.location.reload();
    } 
    if (token == null) {
      return <Navigate to={"/Login"} />;
    }
    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      return <Navigate to={"/Preferences"} />;
    }

    return (
      <>
      
          
        
          {/* Static sidebar for desktop */}
          
          <div className="flex flex-col flex-1">
                  {/* */}

                  <div></div>
                  {/* */}
                  {/* Replace with your content */}
                  <div className="px-4 sm:px-6 lg:px-8">
                    <div className="sm:flex sm:items-center">
                      <div className="sm:flex-auto">
                        <h1 className="text-xl font-semibold text-gray-900">
                          Preference
                        </h1>
                       
                      </div>
                     
                    </div>
                    <div className="mt-8 flex flex-col">
                      <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                          <form onSubmit={this.saveCustomer}>
                      <div className="shadow overflow-hidden sm:rounded-md">
                        <div className="px-4 py-5 bg-white sm:p-6">
                          <div className="grid grid-cols-6 gap-6">

                         
                                {this.state.setting_preference.map((Preference,index)=>(
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                                    <fieldset className="space-y-5">
                                      <div className="relative flex items-start">
                                        <div className="flex items-center h-5">
                                          <input
                                            id={Preference.setting_preference_status}
                                            aria-describedby="discount_preference"
                                            name={Preference.setting_preference_status}
                                            type="checkbox"
                                            checked={Preference.setting_preference_status}
                                            onChange={
                                              this.handleChangeCheckboxdiscountpreference(index)
                                            }
                                            className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                          />
                                        </div>
                                        <div className="ml-3 text-sm">
                                          <label
                                            htmlFor="comments"
                                            className="font-medium text-gray-700"
                                          >
                                           {Preference.name}
                                          </label>
                                          <span
                                            id="discount_preference"
                                            className="text-gray-500"
                                          >
                                            <span className="sr-only"> </span>
                                          </span>
                                        </div>
                                      </div>
                                    </fieldset>
                                  </div>
                                ))}

                            
                          </div>
                        </div>

                        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                          <button
                            type="submit"
                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </form>



                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


   {/* /End replace */}
               
        </div>
        {/**success */}
        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        {this.state.showSucessmsg}
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
        {/** */}
      </>
    );
  }
}

export default Preferences;
